import {Types}  from "../actions/paymentActions";
import _ from "lodash";

import { v4 as uuidv4 } from 'uuid';
import { NotificationManager } from "react-notifications";

const defaultState = {
};

// TRACKING_CATEGORIES
// ACCOUNT_CODES
// CONNECTED_TO_XERO

const reducer = (state, action) => {
  switch (action.type) {


    case Types.PAYMENT_STRIPE_ADD_NEW_CARD: {

      const newState = {...state};

      newState.payment.stripe.addNewCard = action.status

      return newState;
    }


    case Types.PAYMENT_STRIPE_SAVING_CARD: {

      const newState = {...state};

      newState.payment.stripe.savingCard = action.status
      if (!action.status){
        // if saved card then no need to show the new card UI right?
        newState.payment.stripe.addNewCard = false
      }
      
      return newState;
    }


    case Types.STRIPE_PROCESSING_CHARGE: {

      const newState = {...state};

      newState.payment.stripe.processingCharge = true
      newState.payment.stripe.paymentIntent = null
      
      return newState;
    }

    case Types.STRIPE_CREATE_CHARGE: {

      const newState = {...state};

      newState.payment.stripe.processingCharge = false

      if (action.payload.invoiceNo){
        newState.payment.invoiceNo = action.payload.invoiceNo;
      }
      if (action.payload.creditId){
        newState.payment.creditId = action.payload.creditId;

        // delete renewal date property for advisor
        delete newState.advisors.settings.planRenewalDate
        delete newState.advisors.settings.trialExpires
      }

      if (action.payload.invoiceNo){
        newState.payment.newOrganisationID = action.payload.organisationID;

        if (newState?.createAccount?.data?.organisation){
          // we should open the company creation modal to continue

          newState.company.newCompany = {
            id: action.payload.organisationID,
            details: {
              id: action.payload.organisationID,
              name: newState?.createAccount?.data?.organisation,
              vatNo: newState?.createAccount?.data?.vatNo,
              address: {
                number: newState?.createAccount?.data?.door,
                street: newState?.createAccount?.data?.street,
                city: newState?.createAccount?.data?.city,
                postalCode: newState?.createAccount?.data?.postcode,
              }
            },
            overtimes: [],
            allowances: [],
            paySchedules: [{
              id: uuidv4(),
              public: "no",
              name: "Monthly",
              payFrequency: 12,
              deadline: {
                value: "2",
                type: 'days'
              },
              payDay: {
                value: "last day",
                type: 'of the period'
              },
            }]
          }
          newState.company.isNewCompanyModalOpen = true
          newState.payment.modal = false
        }
      }

      if (action.payload.paymentIntent == "success"){
        newState.payment.modal = false
      } else{
        newState.payment.stripe.paymentIntent = action.payload.paymentIntent
      }

      console.log('actionCREATECHARTE',action)
      // newState.payment.selectedBundle = action.bundle
      
      return newState;
    }
    case Types.PAYMENT_SELECT_BUNDLE: {

      const newState = {...state};

      newState.payment.selectedBundle = action.bundle
      
      return newState;
    }
    case Types.PAYMENT_MODAL: {

      const newState = {...state};

      newState.payment.modal = action.status
      newState.payment.isNew = action.isNew

      if (!action.status){
        delete newState.payment.creditId;
      }
      
      return newState;
    }

    case Types.PAYMENT_GET_STATS: {

      const newState = {...state};

      // update fetching status
      newState.payment.fetchingStats = action.fetchingStats
      if (!action.payload){
        // controller is the item to cancel a request if needed
        newState.payment.controller = action.controller
        newState.payment.fetchingId = action.id
        return newState;
      }

      newState.payment.stats = action.payload

      // update status if there was a change in status after a payment for example.
      if (newState.payment.stats.businessDetails.status != newState.company.settings.status){
        newState.company.settings.status = newState.payment.stats.businessDetails.status
      }
      
      return newState;
    }

    case Types.PAYMENT_GET_CREDITS: {
      const newState = {...state};

      newState.payment.credits = action.payload
      
      return newState;
    }
    case Types.PAYMENT_ADVISOR_CREDITS: {
      const newState = {...state};

      newState.advisor.credits = action.payload
      
      return newState;
    }

    case Types.PAYMENT_SELECT_CREDIT: {

        const newState = {...state};

        const advisorCreditIndex = newState?.advisor?.credits?.findIndex?.(credit => credit.id === action.creditId)
        const clientCreditIndex = newState?.payment?.credits?.findIndex?.(credit => credit.id === action.creditId)

        if (advisorCreditIndex > -1){
            newState.advisor.credits[advisorCreditIndex].selected = !newState.advisor.credits[advisorCreditIndex].selected
        }
        if (clientCreditIndex > -1){
            newState.payment.credits[clientCreditIndex].selected = !newState.payment.credits[clientCreditIndex].selected
        }

        newState.payment.hasSelectedCredits = newState?.payment?.credits?.find?.(credit => credit.selected)
        newState.advisor.hasSelectedCredits = newState?.advisor?.credits?.find?.(credit => credit.selected)

        console.log(newState.payment.hasSelectedCredits, newState.advisor.hasSelectedCredits, 'FINDME')
        return newState;
    }

    case Types.PAYMENT_DOWNLOADING: {

      let newState = _.cloneDeep(state);

      if (!newState.invoiceDownloading){
        newState.invoiceDownloading = {}
      }

      newState.invoiceDownloading[action.index] = action.status
      
      return newState;
    }

    case Types.PAYMENT_GET_BUNDLES: {

      const newState = {...state};

      newState.payment.bundles = action.payload


      if (newState.company.settings.plan && state.payment.bundles) {
          const planDetails = state.payment.bundles.find((bundle) => bundle.id == newState.company.settings.plan);
          newState.permissions = {...newState.permissions}
          newState.permissions.plan = planDetails?.permissions;

          if (newState.permissions?.plan?.advisorOnly && !newState.my.profile.isAdmin){
              // check if this user is an advisor else decline all permissions
              if (!newState.my.profile.isAdvisor || newState.my.profile.advisorId != newState.company.settings.advisor){
                  newState.permissions.plan = {};
              }
          }

      }
      
      return newState;
    }

    case Types.STRIPE_LIST: {

      const newState = {...state};

      newState.payment.stripe.list = action.payload
      
      return newState;
    }

    case Types.STRIPE_CREATE_CUSTOMER: {

      const newState = {...state};

      console.log('action.payload',action.payload)

      newState.payment.stats.stripeCustomerID = action.payload.id
      
      return newState;
    }

    case Types.STRIPE_INTENT: {

      const newState = {...state};

      newState.payment.stripe.intent = action.payload
      
      return newState;
    }
    case Types.STRIPE_PAYMENT_METHODS: {

      const newState = {...state};

      newState.payment.stripe.paymentMethods = action.payload

      if(action.payload.length > 0){
        newState.payment.stripe.addNewCard = false
      }
      
      return newState;
    }

    case Types.PAYMENT_ADMIN_SERVICE_LIST: {
        const newState = { ...state };

        newState.payment.serviceList = action.response

        return newState;
    }

    case Types.PAYMENT_SUCCESS_NOTIFICATION: {
      const newState = { ...state }

      delete newState.company.billingModal

      NotificationManager.success(action.message, 'Success')

      return newState
    }
    case Types.PAYMENT_ERROR_NOTIFICATION: {
      const newState = { ...state }

      NotificationManager.error(action.message, 'Error')

      return newState
    }
    case Types.PAYMENT_SHOW_STRIPE_DELETE_MODAL: {
      const newState = _.cloneDeep(state);

      newState.payment.stripeDeleteModal = action.status ? true : undefined;
      newState.payment.stripeDeleteModalId = action.id;
      
      return newState
    }
    case Types.PAYMENT_REMOVE_STRIPE: {
      const newState = _.cloneDeep(state);

      //HERE
      const indexToDelete = newState.payment.stripe.paymentMethods.findIndex(
        (stripeToDel) => { return stripeToDel.id == action.payload});

      newState.payment.stripe.paymentMethods.splice(indexToDelete, 1)

      return newState
    }
    case Types.PAYMENT_TRANSACTION_HISTORY: {
      const newState = _.cloneDeep(state);

      newState.payment.transactionHistory = action.transactionHistory;

      return newState
    }
    case Types.PAYMENT_TRANSACTION_HISTORY_MODAL: {
      const newState = _.cloneDeep(state);

      newState.payment.transactionHistoryModal = action.status;
      newState.payment.transactionHistoryModalTransaction = action.transaction;

      if (!action.status){
        newState.payment.transactionHistory = []
      }

      return newState
    }

    default:
      return state;
  }
};

export default reducer;